/**
 * useOrganisation Hook
 *
 * Fetches a single organisation's detail from the Rails API. Accepts an
 * optional server-rendered seed via `initialData` so detail pages render
 * without a client-side refetch.
 */

import { useQuery } from '@tanstack/react-query';
import { organisationsQueryKeys, getOrganisation } from '../../api/organisations';
import type { OrganisationShowResponse } from '../../api/organisations';

const STALE_TIME = 30_000;

interface UseOrganisationOptions {
  initialData?: OrganisationShowResponse;
}

export function useOrganisation(id: number, { initialData }: UseOrganisationOptions = {}) {
  return useQuery({
    queryKey: organisationsQueryKeys.detail(id),
    queryFn: () => getOrganisation(id),
    staleTime: STALE_TIME,
    select: (data) => data.organisation,
    ...(initialData ? { initialData, initialDataUpdatedAt: Date.now() } : {}),
  });
}
